import React from 'react';
import {
  View, Text, FlatList, Image,
} from 'react-native';
import { Button, Dialog, Portal } from 'react-native-paper';

function EquipmentOnBagHistoryDialog({ visible, onDismiss, history }) {
  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Title>Historique des modifications</Dialog.Title>
        <Dialog.Content>
          <FlatList
            data={history}
            keyExtractor={(item) => item.id.toString()}
            renderItem={({ item }) => (
              <View style={{ marginBottom: 10 }}>
                <Text>Date: {new Date(item.createdAt).toLocaleString()}</Text>
                <Text>Qualité: {item.qualityGrade}</Text>
                {item.picture && (
                  <Image
                    source={{ uri: `data:image/jpeg;base64,${item.picture}` }}
                    style={{ width: 100, height: 100 }}
                  />
                )}
              </View>
            )}
          />
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss}>Fermer</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
}

export default EquipmentOnBagHistoryDialog;
